import Icon from "@alboompro/boom-components/general/icon";

import React, { forwardRef } from "react";
import { CustomInputWrapper } from "./styles";

export const CustomInput = forwardRef(({ value, onClick }, ref) => {
  return (
    <CustomInputWrapper onClick={onClick} ref={ref}>
      <Icon
        kind="bold"
        group="interface-essential"
        category="edit"
        file="pencil.svg"
        size="12"
        color="#50aff4"
      />
      <input type="button" value={value.substr(0, value.length - 3)} />
    </CustomInputWrapper>
  );
});
